module.exports = __webpack_public_path__ + "static/media/kevin_mac_allister.cc04df65.jpg";